export default {
    modal_title: "Add waste cloth",
    unit_price: "Unit price",
    quantity: "Quantity",
    subtotal_with_colon: "Subtotal:",
    cancel: "Cancel",
    add: "Add",
    client_search_placeholder: "Search client...",
    client_1: "Client 1",
    client_2: "Client 2",
    client_3: "Client 3",
    product_search_placeholder: "Search product...",
    product_1: "Product 1",
    product_2: "Product 2",
    product_3: "Product 3",
    product: "Product",
    subtotal: "Subtotal",
    total: "Total",
    add_product: "Add product",
    advance_payment: "Continue to payment",
    coupon: "Coupon",
    apply: "Apply",
    save_sale: "Save sale",
    sale_success: "Sale completed successfully!",
    new_sale: "New sale",
};
